function ConsentCheckboxes({
  smsConsent,
  setSmsConsent,
  termsConsent,
  setTermsConsent,
  errors = {},
}) {
  return (
    <div className="consent-box">
      <label className="checkbox-group">
        <input
          type="checkbox"
          checked={smsConsent}
          onChange={(e) => setSmsConsent(e.target.checked)}
        />
        <span>
          I agree to receive SMS messages from Bluprint regarding time OTP and Forget Password
          updates. Message frequency varies. Message and data rates may apply. Text HELP for help.
          Text STOP to cancel. <span className="optional-tag">(optional)</span>
        </span>
      </label>

      <label
        className={`checkbox-group ${errors.termsConsent ? 'checkbox-error' : ''}`}
        style={{ marginBottom: 0, marginTop: 10 }}
      >
        <input
          type="checkbox"
          checked={termsConsent}
          onChange={(e) => setTermsConsent(e.target.checked)}
          aria-invalid={!!errors.termsConsent}
          aria-required="true"
        />
        <span>
          <span className="required-star">*</span> I agree to the{' '}
          <a
            href="https://www.thebluprint.app/terms-conditions/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms and Conditions
          </a>{' '}
          |{' '}
          <a
            href="https://www.thebluprint.app/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </span>
      </label>
      {errors.termsConsent && <div className="field-error">{errors.termsConsent}</div>}
    </div>
  );
}

export default ConsentCheckboxes;
